import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Edit } from '@material-ui/icons';
import { includes } from 'lodash';

import {
  deletePostoPlanejamento,
  findPostoPlanejamento,
  recordFiltering,
} from '~/store/modules/postoplanejamento/actions';
import { UnidataTable } from '~/components';
import { ADM, GFE } from '~/constants/perfil';

import Form from './components/Form';

function PostoPlanejamentoList() {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const data = useSelector((state) => state.postoplanejamento);

  const [modal, setModal] = useState(false);
  const [rendering, setRendering] = useState(false);
  const [params, setParams] = useState({});
  const testeUser = useSelector((state) => state.user);

  const { glousuariotipo, gloperfilid } = useSelector((state) => state.user.profile);




  const optionsStatus = useMemo(
    () => [
      { label: 'Liberado', value: 'Liberado' },
      { label: 'Bloqueado', value: 'Bloqueado' },
      { label: 'Cancelado', value: 'Cancelado' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'poco_codigo',
        label: 'Código',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'poco_descricao',
        label: 'Posto',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'poco_desc_abrev',
        label: 'Descrição Abrev.',
        filter: { type: 'text' },
      },
      {
        id: 'poco_nome_fantasia',
        label: 'Nome Fantasia',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'orga_nome',
        label: 'Nome do Órgão',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'unid_nome',
        label: 'Nome da Unidade',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'poco_endereco',
        label: 'Endereço',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'poco_telefone',
        label: 'Telefone',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'poco_cep',
        label: 'CEP',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'muni_nome',
        label: 'Município',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'poco_status_str',
        label: 'Status',
        filter: {
          type: 'select',
          options: optionsStatus,
        },
      },
    ],
    [optionsStatus]
  );

  const buttons = useMemo(() => {
    const button = [];

    if (includes([ADM, GFE], glousuariotipo) && gloperfilid != 67) {
      button.push({
        title: 'Alterar',
        action: (value) => handleOpenModalEdit(value),
        icon: <Edit />,
      });
    }

    return button;
  }, [glousuariotipo, ADM, GFE]);

  const handleOpenModalEdit = useCallback((values) => {
    setModal(true);
    setParams(values);
  }, []);

  const handleCloseModalEdit = useCallback(() => {
    setModal(false);
    setParams({});
    setRendering(true);
  }, []);

  useEffect(() => {
    if (modal) formRef.current.openModal();
  }, [modal]);

  useEffect(() => {
    if (rendering && !modal) {
      setRendering(false);
      dispatch(recordFiltering(data.params));
    }
  }, [rendering, data.params, modal]);

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="poco_codigo ASC"
        fixed
        header={header}
        redux={data}
        actions={buttons}
        read={recordFiltering}
        remove={deletePostoPlanejamento}
        find={findPostoPlanejamento}
        create={false}
        update={false}
        detach="poco_codigo"
        keys="poco_codigo"
        view="VW_POSTO"
        reportTitle="Posto Planejamento e Controle"
      />

      {modal && (
        <Form
          ref={formRef}
          onCloseModal={handleCloseModalEdit}
          formEdit={params}
        />
      )}
    </>
  );
}

export default PostoPlanejamentoList;
